import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api, { setSessionLostHandler } from "@/lib/api/client";
import { useAuthStore } from "@/app/store/auth.store";
import { queryClient } from "@/lib/api/queryClient";

export function AuthProvider({ children }) {
  const navigate = useNavigate();
  const { setSession, finishBootstrap, clear } = useAuthStore();

  useEffect(() => {
    setSessionLostHandler(() => {
      queryClient.clear();
      clear();
      navigate("/login", { replace: true });
    });
  }, [navigate, clear]);

  useEffect(() => {
    // The access token is memory-only, so a page reload always starts with no
    // token. The refresh cookie is what makes that survivable: one silent call
    // on boot restores the session, or confirms there is none.
    let cancelled = false;

    (async () => {
      try {
        const res = await api.post("/auth/refresh");
        if (!cancelled) {
          setSession({
            accessToken: res.data.accessToken,
            user: res.data.user,
            permissions: res.data.permissions,
          });
        }
      } catch {
        if (!cancelled) finishBootstrap(); // no session -- not an error
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [setSession, finishBootstrap]);

  return children;
}
